import { flow } from 'lodash-es';
import { filterEmpty } from './filter-empty';
import { mergeFacets } from './merge';
import { groupFacets } from './group';
import { enrichWithConfig } from './enrich-with-config';
import { sortFacetsInGroups } from './sort';

export const processFacets = ({ facets, facetsConfig, groupsConfig, subgroupsConfig }) => {
  return flow(
    enrichWithConfig(facetsConfig, subgroupsConfig),
    filterEmpty,
    mergeFacets(subgroupsConfig),
    groupFacets(groupsConfig),
    sortFacetsInGroups
  )(facets);
};
